import { createAsyncThunk } from "@reduxjs/toolkit";
import getApiUrl from "../../../api";

const asyncPaycheckDownload = createAsyncThunk(
    'paycheck/download',
    async function({year, month}) {
        console.log(month);
        const accessToken = sessionStorage.access;
        const promise = await fetch(getApiUrl() + `/api/paycheck/download?year=${year}&month=${month}`, {
            headers: {
                "Authorization": `Bearer ${accessToken}`,
                'Content-Type': "application/pdf"
            }
        });

        const json = await promise.json();
        const {base64data} = json.data;

        const linkSource = `data:application/pdf;base64,${base64data}`;
        const downloadLink = document.createElement("a");
        const fileName = `paycheck-${year}-${month}.pdf`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        downloadLink.remove();
    }
)

export default asyncPaycheckDownload;